import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BankStatementDesignerComponent } from './bank-statement-designer/bank-statement-designer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PrimengModule } from './primeng.module';
import { PrintBankStatementsComponent } from './print-bank-statements/print-bank-statements.component';
import { ThousandsFormPipe } from 'src/shared/pipes/thousands-form.pipe';

@NgModule({
  declarations: [
    AppComponent,
    BankStatementDesignerComponent,
    PrintBankStatementsComponent,
    ThousandsFormPipe,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    PrimengModule,
    ReactiveFormsModule,
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
